import { makeAutoObservable } from 'mobx'
import _ from 'lodash/fp'

export class Customer {

	type

	ean

	cvr

	name

	location

	department

	address

	zip_code

	city

	invoice_email

	email

	phone

	person_ref

	order_nr

	heard_about

	heard_about_value

	acceptance = false
	/** @type string|null */
	payment_method = null

	get paymentMethod(){
		if (this.availablePaymentMethods.length === 1) {
			this.payment_method = this.availablePaymentMethods[0]
		}
		return this.payment_method
	}

	constructor() {
    makeAutoObservable(this)
  }

	get availablePaymentMethods(){
		return _.compact([
      this.canPayWithNets ? 'nets' : null,
      this.canPayWithInvoice ? 'invoice' : null
    ])
	}
  get canPayWithNets() {
		return _.includes(this.type, ['public', 'business', 'private'])
  }

  get canPayWithInvoice() {
		return _.includes(this.type, ['public', 'business'])
  }
}